import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { Callout } from '../layout/Callout';
import { Link } from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import { OUTCOME_EDITOR_CLASS_NAME } from './OutcomeScenariosEditor';
import { OutcomeScenario } from '@decisions/server/DecisionsFramework/ServiceLayer/OutcomeScenario';
import { OutcomeType } from '@decisions/server/DecisionsFramework/ServiceLayer/OutcomeType';
import { splitCamelCase } from 'utils/StringUtils';

export interface IOutcomeScenarioProps {
  outcomeScenario: OutcomeScenario;
  onSelect?: (action: any) => void;
  labelClassName?: string;
  buttonClassName?: string;
  calloutClassName?: string;
}

const getClassNames = (isSelected: boolean) =>
  classNames(`${OUTCOME_EDITOR_CLASS_NAME}__outcome`, {
    [`${OUTCOME_EDITOR_CLASS_NAME}__outcome--selected`]: isSelected,
  });

export function OutcomeScenarioLinkButton({
  outcomeScenario,
  onSelect,
  labelClassName,
  buttonClassName,
}: IOutcomeScenarioProps) {
  const [isOpen, setIsOpen] = useState(false);
  const linkLabel = splitCamelCase(OutcomeType[outcomeScenario.OutcomeType]);
  const button = useRef<HTMLButtonElement>(null);

  const toggleOpen = useCallback(() => {
    setIsOpen(o => !o);
  }, [setIsOpen]);

  const setClosed = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleClick = useCallback(
    (value: OutcomeType) => {
      if (value === outcomeScenario.OutcomeType) {
        setClosed();
        return;
      }
      outcomeScenario.OutcomeType = value;
      onSelect && onSelect(outcomeScenario);
      setClosed();
    },
    [onSelect, setClosed, outcomeScenario]
  );

  return (
    <div className={`${OUTCOME_EDITOR_CLASS_NAME}__content`}>
      <span title={outcomeScenario.OutcomePath} className={classNames(labelClassName)}>
        {outcomeScenario.OutcomePath}
      </span>
      <Link
        title={linkLabel}
        aria-label={linkLabel}
        component="button"
        onClick={toggleOpen}
        ref={button}
        className={classNames(buttonClassName, `${OUTCOME_EDITOR_CLASS_NAME}__outcome-link`, {
          [`${OUTCOME_EDITOR_CLASS_NAME}__outcome-link--opened`]: isOpen,
        })}
      >
        {linkLabel}
        <KeyboardArrowDown className={`${OUTCOME_EDITOR_CLASS_NAME}__arrow-down`} />
      </Link>
      <Callout isOpen={isOpen} sourceRef={button} onClose={setClosed} showArrow={true} flipBehavior="flip">
        <div className={`${OUTCOME_EDITOR_CLASS_NAME}__outcome-list`}>
          {Object.keys(OutcomeType)
            .filter(val => isNaN(Number(val))) //in case of Enum Object.Keys will give value and key both as output hence added a filter
            .map(key => (
              <span
                key={key}
                className={getClassNames(OutcomeType[outcomeScenario.OutcomeType] === key)}
                onClick={() => handleClick(OutcomeType[key as keyof typeof OutcomeType])}
              >
                {splitCamelCase(key)}
              </span>
            ))}
        </div>
      </Callout>
    </div>
  );
}
